import { IconDownload, IconEye } from '@tabler/icons-react';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './CompactFileList.module.scss';
import { Props } from './CompactFileList.types';

const CompactFileList = ({ files, onFileClick }: Props) => {
  const { t } = useTranslation();

  const downloadFile = useCallback((e: React.MouseEvent, url: string) => {
    e.stopPropagation();
    const newTab = window.open(url, '_blank');

    if (newTab) {
      newTab.focus();
    }
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.title}>{t('compactFileList.documents', 'Documents')}</div>
      {files.map(file => (
        <div key={file.id} className={styles.fileLine} onClick={() => onFileClick?.(file.id)}>
          <div className={styles.fileName}>{file.name}</div>
          <div className={styles.actions}>
            {onFileClick && (
              <IconEye
                size={20}
                className={styles.actionIcon}
                onClick={() => onFileClick(file.id)}
              />
            )}
            <IconDownload
              size={20}
              className={styles.actionIcon}
              onClick={e => downloadFile(e, file.publicUrl)}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default CompactFileList;
